import { render, staticRenderFns } from "./user-group-stat.vue?vue&type=template&id=76c6da80&scoped=true&"
import script from "./user-group-stat.vue?vue&type=script&lang=js&"
export * from "./user-group-stat.vue?vue&type=script&lang=js&"
import style0 from "./user-group-stat.vue?vue&type=style&index=0&id=76c6da80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c6da80",
  null
  
)

export default component.exports